export default __webpack_public_path__ + "static/media/bkw.16a56af5.png";